import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, NgModule, Inject, Injectable, Pipe, ChangeDetectionStrategy, Directive, EventEmitter, Input, Output } from '@angular/core';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { FormControl } from '@angular/forms';
import * as i1$2 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule } from '@angular/material/snack-bar';
import DOMPurify from 'dompurify';
import * as i1$1 from '@angular/platform-browser';
import * as i1$3 from '@angular/material/tooltip';

class OneBannerComponent {
}
OneBannerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBannerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OneBannerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneBannerComponent, selector: "one-banner", ngImport: i0, template: "<div class=\"one-banner-wrapper\">\n  <ng-content select=\"one-banner-content\"></ng-content>\n  <ng-content select=\"one-banner-actions\"></ng-content>\n</div>\n", styles: ["one-banner{align-self:flex-end}one-banner .one-banner-wrapper{max-width:700px;position:absolute;left:50px;right:50px;margin:1px auto 0;z-index:3;-webkit-animation:slide-bottom .5s cubic-bezier(.25,.46,.45,.94) both;animation:slide-bottom .5s cubic-bezier(.25,.46,.45,.94) both;border-radius:0 0 4px 4px;padding:16px;white-space:normal;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 20px 14px 2px #0000001f}@-webkit-keyframes slide-bottom{0%{transform:translateY(-48px)}to{transform:translateY(0)}}@keyframes slide-bottom{0%{transform:translateY(-48px)}to{transform:translateY(0)}}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBannerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-banner',
                    templateUrl: './banner.component.html',
                    styleUrls: ['./banner.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }] });

class OneBannerContentComponent {
}
OneBannerContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBannerContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OneBannerContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneBannerContentComponent, selector: "one-banner-content", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [".mat-select-panel.ng-animating{visibility:hidden}.mat-select-panel.one-select-panel-small{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f;margin-left:16px;padding:8px 0!important;min-width:100%!important;border-radius:4px;margin-top:28px}.mat-select-panel.one-select-panel-small .mat-option{height:48px}.mat-select-panel.one-select-panel-small .mat-option .mat-option-ripple .mat-ripple-element{opacity:.5}.mat-select-panel.one-select-panel-small .mat-option .mat-option-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:14px}.mat-select-panel.one-select-panel-small .mat-option.mat-selected{padding-left:12px}.mat-select-panel.one-select-panel-small.one-select-panel-multiple{margin-left:40px}.mat-select-panel.one-select-panel-big{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f;margin-left:16px;padding:8px 0!important;min-width:100%!important;border-radius:4px;margin-top:31px}.mat-select-panel.one-select-panel-big .mat-option{height:48px}.mat-select-panel.one-select-panel-big .mat-option .mat-option-ripple .mat-ripple-element{opacity:.5}.mat-select-panel.one-select-panel-big .mat-option .mat-option-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:14px}.mat-select-panel.one-select-panel-big .mat-option.mat-selected{padding-left:12px}.mat-select-panel.one-select-panel-big.one-select-panel-multiple{margin-left:40px;margin-top:27px}.mat-select-panel.one-select-panel-optgroup .mat-optgroup .mat-option{padding-left:32px}.mat-select-panel.one-select-panel-optgroup .mat-optgroup .mat-option.mat-selected{padding-left:28px}.mat-select-panel.one-select-panel-optgroup.one-select-panel-multiple .mat-optgroup .mat-option{padding-left:32px}.mat-select-panel.one-select-panel-optgroup.one-select-panel-multiple .mat-optgroup .mat-option.mat-selected{padding-left:28px}.mat-select-panel.one-select-panel-optgroup.one-select-panel-multiple{margin-left:38px;margin-top:31px}.cdk-overlay-backdrop.cdk-overlay-dark-backdrop{background:rgba(0,0,0,.5)}one-banner-content{font:400 14px / 1.2 Roboto,\"Helvetica Neue\",sans-serif;letter-spacing:normal;text-align:left}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBannerContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-banner-content',
                    templateUrl: './banner-content.component.html',
                    styleUrls: ['./banner-content.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }] });

class OneBannerActionsComponent {
}
OneBannerActionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBannerActionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OneBannerActionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneBannerActionsComponent, selector: "one-banner-actions", ngImport: i0, template: "<ng-content></ng-content>\n", styles: ["one-banner-actions{padding-top:24px;display:flex;justify-content:flex-end}one-banner-actions .mat-button-base+.mat-button-base{margin-left:24px}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBannerActionsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-banner-actions',
                    templateUrl: './banner-actions.component.html',
                    styleUrls: ['./banner-actions.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }] });

class OneBannerModule {
}
OneBannerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBannerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneBannerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBannerModule, declarations: [OneBannerComponent, OneBannerContentComponent, OneBannerActionsComponent], imports: [CommonModule], exports: [OneBannerComponent, OneBannerContentComponent, OneBannerActionsComponent] });
OneBannerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBannerModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBannerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneBannerComponent, OneBannerContentComponent, OneBannerActionsComponent],
                    imports: [CommonModule],
                    exports: [OneBannerComponent, OneBannerContentComponent, OneBannerActionsComponent]
                }]
        }] });

class OneDialogSubtitleComponent {
}
OneDialogSubtitleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogSubtitleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OneDialogSubtitleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneDialogSubtitleComponent, selector: "one-dialog-subtitle", ngImport: i0, template: "<ng-content></ng-content>\n", styles: ["one-dialog-subtitle{display:flex;padding:10px 16px;font-size:14px;margin:0 -16px;line-height:18px}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogSubtitleComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-dialog-subtitle',
                    templateUrl: './dialog-subtitle.component.html',
                    styleUrls: ['./dialog-subtitle.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }] });

class OneDialogModule {
}
OneDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogModule, declarations: [OneDialogSubtitleComponent], imports: [CommonModule], exports: [OneDialogSubtitleComponent] });
OneDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneDialogSubtitleComponent],
                    exports: [OneDialogSubtitleComponent],
                    imports: [CommonModule]
                }]
        }] });

class OneDialogConfirmationComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.iconName = null;
        this.iconColor = 'inherit';
        this.iconName = data.iconName;
        this.iconColor = data.iconColor || '#333';
    }
}
OneDialogConfirmationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogConfirmationComponent, deps: [{ token: i1.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
OneDialogConfirmationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneDialogConfirmationComponent, selector: "one-dialog-confirmation", ngImport: i0, template: "<div mat-dialog-title oneDialogTitle>\n  <mat-icon *ngIf=\"iconName\" [ngStyle]=\"{ color: iconColor }\">{{ iconName }}</mat-icon>\n  {{ data.title }}\n</div>\n<div class=\"mat-body\" mat-dialog-content oneDialogContent>\n  <div [innerHtml]=\"data.content\"></div>\n</div>\n<div mat-dialog-actions oneDialogActions>\n  <button (click)=\"dialogRef.close(false)\" one-secondary-button mat-stroked-button>\n    {{ data.cancelButton }}\n  </button>\n  <button (click)=\"dialogRef.close(true)\" color=\"primary\" mat-flat-button>{{ data.confirmButton }}</button>\n</div>\n", styles: ["one-dialog-confirmation .mat-dialog-content{display:flex;flex-direction:column;padding:24px}\n"], components: [{ type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogConfirmationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-dialog-confirmation',
                    templateUrl: './dialog-confirmation.component.html',
                    styleUrls: ['./dialog-confirmation.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: function () { return [{ type: i1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

class OneDialogConfirmationService {
    constructor(dialog) {
        this.dialog = dialog;
    }
    /**
     * Opens a predesigned dialog only used to confirm an action, situation, ...
     * @param title Dialog's title
     * @param content Body to be added
     * @param confirmButton Button's label that would return true
     * @param cancelButton Button's label that would return false
     * @param iconName Official icon name from OneDesignKit Icon library
     * @param iconColor Color definition, in form of hex, rgb, rgba.
     */
    open(title, content, confirmButton, cancelButton, iconName, iconColor) {
        return this.dialog.open(OneDialogConfirmationComponent, {
            width: '536px',
            disableClose: true,
            autoFocus: false,
            data: { title, content, confirmButton, cancelButton, iconName, iconColor },
        });
    }
}
OneDialogConfirmationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogConfirmationService, deps: [{ token: i1.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
OneDialogConfirmationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogConfirmationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogConfirmationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.MatDialog }]; } });

class OneDialogConfirmationModule {
}
OneDialogConfirmationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogConfirmationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneDialogConfirmationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogConfirmationModule, declarations: [OneDialogConfirmationComponent], imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule] });
OneDialogConfirmationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogConfirmationModule, providers: [OneDialogConfirmationService], imports: [[CommonModule, MatDialogModule, MatIconModule, MatButtonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDialogConfirmationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneDialogConfirmationComponent],
                    imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule],
                    providers: [OneDialogConfirmationService],
                    entryComponents: [OneDialogConfirmationComponent]
                }]
        }] });

var OneSnackBarType;
(function (OneSnackBarType) {
    OneSnackBarType["SUCCESS"] = "success";
    OneSnackBarType["WARNING"] = "warning";
    OneSnackBarType["ERROR"] = "error";
    OneSnackBarType["INFO"] = "info";
})(OneSnackBarType || (OneSnackBarType = {}));

class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type) {
        if (type === 'html') {
            return this.sanitizer.bypassSecurityTrustHtml(value);
        }
        else {
            throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
}
SafePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: SafePipe, deps: [{ token: i1$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: SafePipe, name: "safe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: SafePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safe',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.DomSanitizer }]; } });

class OneSnackBarComponent {
    constructor(data, snackBarRef, renderer, el) {
        this.data = data;
        this.snackBarRef = snackBarRef;
        this.renderer = renderer;
        this.el = el;
        this.statusIcon = null;
        this.buttonActionClicked = new FormControl();
        this.MIN_HEIGHT = 72;
        this.LINE_HEIGHT = 19;
        this.data.message = DOMPurify.sanitize(this.data.message);
    }
    ngOnInit() {
        this.setStatus();
    }
    ngAfterViewChecked() {
        const snackbarHeight = this.el.nativeElement.querySelector('.one-snack-bar');
        const actionButton = this.el.nativeElement.querySelector('.one-snack-bar-action > button');
        const content = this.el.nativeElement.querySelector('.one-snack-bar-content');
        const span = this.el.nativeElement.querySelector('.mat-body-2');
        if (!actionButton && span.clientHeight > this.LINE_HEIGHT) {
            const message = this.el.nativeElement.querySelector('.one-snack-bar-message');
            this.renderer.setStyle(message, 'padding-bottom', '26px');
        }
        // handle actionButton alignment with dissmiss button
        if (actionButton && snackbarHeight.clientHeight > this.MIN_HEIGHT) {
            this.contentWidth = content.clientWidth;
            this.renderer.setStyle(actionButton, 'margin-right', '-40px');
        }
        if (actionButton && content.clientWidth <= this.contentWidth && snackbarHeight.clientHeight === this.MIN_HEIGHT) {
            this.renderer.setStyle(actionButton, 'margin-top', '45px');
        }
    }
    getStatus() {
        return this.data.message;
    }
    getStatusClassName() {
        return this.data.messageType;
    }
    actionClicked() {
        this.buttonActionClicked.setValue(true);
    }
    getActionStatus() {
        return this.buttonActionClicked;
    }
    dismissClicked() {
        this.snackBarRef.dismissWithAction();
    }
    setStatus() {
        switch (this.data.messageType) {
            case OneSnackBarType.SUCCESS:
                this.statusIcon = 'yes';
                break;
            case OneSnackBarType.WARNING:
                this.statusIcon = 'alarm';
                break;
            case OneSnackBarType.ERROR:
                this.statusIcon = 'alarm';
                break;
            case OneSnackBarType.INFO:
                this.statusIcon = 'info';
                break;
            default:
                throw new Error('Invalid status for SnackBar');
        }
    }
}
OneSnackBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSnackBarComponent, deps: [{ token: MAT_SNACK_BAR_DATA }, { token: i1$2.MatSnackBarRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
OneSnackBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneSnackBarComponent, selector: "one-snack-bar", ngImport: i0, template: "<div class=\"one-snack-bar\" [ngClass]=\"getStatusClassName()\">\n  <div class=\"one-snack-bar-icon-container\">\n    <mat-icon>{{ statusIcon }}</mat-icon>\n  </div>\n  <div class=\"one-snack-bar-content\">\n    <div class=\"one-snack-bar-message\">\n      <span [innerHTML]=\"data?.message | safe: 'html'\" class=\"mat-body-2\"></span>\n    </div>\n    <div class=\"one-snack-bar-action\" *ngIf=\"data?.action\">\n      <button one-secondary-button mat-stroked-button (click)=\"actionClicked()\">{{ data?.action }}</button>\n    </div>\n  </div>\n  <div class=\"one-snack-bar-dismiss\">\n    <button mat-icon-button one-icon-button matSuffix (click)=\"dismissClicked()\">\n      <mat-icon matSuffix>close</mat-icon>\n    </button>\n  </div>\n</div>\n", styles: [".one-snack-bar-container.mat-snack-bar-container{padding:0}@media screen and (max-width: 719px){.one-snack-bar-container.mat-snack-bar-container{max-width:100vw}}@media screen and (min-width: 720px) and (max-width: 1023px){.one-snack-bar-container.mat-snack-bar-container{max-width:50vw}}one-snack-bar .one-snack-bar{display:flex;min-height:72px;min-width:400px;max-width:500px;border-radius:4px;box-sizing:border-box;box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}one-snack-bar .one-snack-bar .one-snack-bar-icon-container{display:flex;justify-content:center;min-width:72px;width:72px;border-top-left-radius:4px;border-bottom-left-radius:4px}one-snack-bar .one-snack-bar .one-snack-bar-icon-container .mat-icon{width:40px;height:40px;font-size:40px;margin-top:14px}one-snack-bar .one-snack-bar .one-snack-bar-content{display:flex;flex-wrap:wrap;width:100%;justify-content:flex-end;padding:0 56px 0 16px;border:2px solid;border-top-right-radius:4px;border-bottom-right-radius:4px}one-snack-bar .one-snack-bar .one-snack-bar-content .one-snack-bar-message{flex-grow:1;padding-top:27px;word-break:break-word;margin-right:5px}one-snack-bar .one-snack-bar .one-snack-bar-content .one-snack-bar-message .mat-body-2{display:box;-webkit-line-clamp:4;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}one-snack-bar .one-snack-bar .one-snack-bar-content .one-snack-bar-action{align-self:flex-end;margin-bottom:16px;margin-top:5px}one-snack-bar .one-snack-bar .one-snack-bar-dismiss{position:absolute;top:18px;right:8px;cursor:pointer}\n"], components: [{ type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "safe": SafePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSnackBarComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-snack-bar',
                    templateUrl: './snack-bar.component.html',
                    styleUrls: ['./snack-bar.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_SNACK_BAR_DATA]
                }] }, { type: i1$2.MatSnackBarRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }]; } });

class OneSnackBarService {
    constructor(matSnackBar) {
        this.matSnackBar = matSnackBar;
    }
    /**
     * Open one-snack-bar with the setup provided and configuration
     * @param message String that will appear inside snack-bar
     * @param messageType Type of snackbar that is shown
     * @param action if provided, label of action button
     * @param config Standard MatSnackBarConfig object
     */
    open(message, messageType, action, config) {
        const defaultConfig = {
            verticalPosition: 'top',
            horizontalPosition: 'right',
            panelClass: 'one-snack-bar-container',
        };
        config = Object.assign(Object.assign(Object.assign({}, defaultConfig), config), { data: { message, messageType, action }, panelClass: this.extendPanelClassConfig(defaultConfig.panelClass, config === null || config === void 0 ? void 0 : config.panelClass) });
        return this.matSnackBar.openFromComponent(OneSnackBarComponent, config);
    }
    extendPanelClassConfig(defaultPanelClass, userPanelClass) {
        if (userPanelClass) {
            if (!Array.isArray(userPanelClass)) {
                userPanelClass = [userPanelClass];
            }
            return [...userPanelClass, defaultPanelClass];
        }
        else {
            return [defaultPanelClass];
        }
    }
}
OneSnackBarService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSnackBarService, deps: [{ token: i1$2.MatSnackBar }], target: i0.ɵɵFactoryTarget.Injectable });
OneSnackBarService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSnackBarService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSnackBarService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.MatSnackBar }]; } });

class OneSnackBarModule {
}
OneSnackBarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSnackBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneSnackBarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSnackBarModule, declarations: [OneSnackBarComponent, SafePipe], imports: [CommonModule, MatButtonModule, MatSnackBarModule, MatIconModule], exports: [OneSnackBarComponent] });
OneSnackBarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSnackBarModule, providers: [OneSnackBarService], imports: [[CommonModule, MatButtonModule, MatSnackBarModule, MatIconModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSnackBarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneSnackBarComponent, SafePipe],
                    imports: [CommonModule, MatButtonModule, MatSnackBarModule, MatIconModule],
                    exports: [OneSnackBarComponent],
                    providers: [OneSnackBarService],
                    entryComponents: [OneSnackBarComponent],
                }]
        }] });

class OneTooltipDirective {
    constructor(matTooltip) {
        this.matTooltip = matTooltip;
    }
    ngAfterViewInit() {
        this.matTooltip.tooltipClass = 'one-tooltip';
    }
}
OneTooltipDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTooltipDirective, deps: [{ token: i1$3.MatTooltip }], target: i0.ɵɵFactoryTarget.Directive });
OneTooltipDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.5", type: OneTooltipDirective, selector: "[oneTooltip]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[oneTooltip]'
                }]
        }], ctorParameters: function () { return [{ type: i1$3.MatTooltip }]; } });

class OneTooltipModule {
}
OneTooltipModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneTooltipModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTooltipModule, declarations: [OneTooltipDirective], imports: [CommonModule], exports: [OneTooltipDirective] });
OneTooltipModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTooltipModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneTooltipDirective],
                    exports: [OneTooltipDirective],
                    imports: [CommonModule]
                }]
        }] });

var OneStaticBannerType;
(function (OneStaticBannerType) {
    OneStaticBannerType["SUCCESS"] = "success";
    OneStaticBannerType["WARNING"] = "warning";
    OneStaticBannerType["ERROR"] = "error";
    OneStaticBannerType["INFO"] = "info";
})(OneStaticBannerType || (OneStaticBannerType = {}));

class OneStaticBannerComponent {
    constructor() {
        this.statusIcon = null;
        this.dismiss = new EventEmitter();
    }
    ngOnInit() {
        this.setStatus();
    }
    actionClicked() {
        this.dismiss.emit(true);
    }
    getStatusClassName() {
        return this.type;
    }
    setStatus() {
        switch (this.type) {
            case OneStaticBannerType.SUCCESS:
                this.statusIcon = 'yes';
                break;
            case OneStaticBannerType.WARNING:
                this.statusIcon = 'alarm';
                break;
            case OneStaticBannerType.ERROR:
                this.statusIcon = 'alarm';
                break;
            case OneStaticBannerType.INFO:
                this.statusIcon = 'info';
                break;
            default:
                throw new Error('Invalid status for static-banner');
        }
    }
}
OneStaticBannerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneStaticBannerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OneStaticBannerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneStaticBannerComponent, selector: "one-static-banner", inputs: { type: "type", dismissible: "dismissible" }, outputs: { dismiss: "dismiss" }, ngImport: i0, template: "<div class=\"one-static-banner\" [ngClass]=\"getStatusClassName()\">\n  <div class=\"one-static-banner-icon-container\">\n    <mat-icon>{{ statusIcon }}</mat-icon>\n  </div>\n  <div class=\"one-static-banner-content-container\">\n    <ng-content></ng-content>\n  </div>\n  <div class=\"one-static-banner-action\" *ngIf=\"dismissible\">\n    <button mat-icon-button one-icon-button matSuffix (click)=\"actionClicked()\">\n      <mat-icon matSuffix>close</mat-icon>\n    </button>\n  </div>\n</div>\n", styles: ["one-static-banner .one-static-banner{display:flex;min-height:72px;padding:0 12px 0 0;box-sizing:border-box;border-style:solid}one-static-banner .one-static-banner .one-static-banner-icon-container{display:flex;justify-content:center;width:72px;padding:12px}one-static-banner .one-static-banner .one-static-banner-icon-container .mat-icon{width:40px;height:40px;font-size:40px}one-static-banner .one-static-banner .one-static-banner-content-container{display:flex;align-content:stretch;flex-wrap:wrap;width:100%;justify-content:flex-end;padding:12px;word-break:break-word;align-items:center}one-static-banner .one-static-banner .one-static-banner-content-container .one-static-banner-content{flex-grow:1;display:flex;align-items:center}one-static-banner .one-static-banner .one-static-banner-content-container .one-static-banner-custom-button{align-self:flex-end;margin-bottom:3px;margin-top:3px}one-static-banner .one-static-banner .one-static-banner-action{display:flex;padding-right:6px;padding-top:12px}\n"], components: [{ type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneStaticBannerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-static-banner',
                    templateUrl: './static-banner.component.html',
                    styleUrls: ['./static-banner.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { type: [{
                type: Input
            }], dismissible: [{
                type: Input
            }], dismiss: [{
                type: Output
            }] } });

class OneStaticBannerModule {
}
OneStaticBannerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneStaticBannerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneStaticBannerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneStaticBannerModule, declarations: [OneStaticBannerComponent], imports: [CommonModule, MatButtonModule, MatIconModule], exports: [OneStaticBannerComponent] });
OneStaticBannerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneStaticBannerModule, imports: [[CommonModule, MatButtonModule, MatIconModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneStaticBannerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneStaticBannerComponent],
                    imports: [CommonModule, MatButtonModule, MatIconModule],
                    exports: [OneStaticBannerComponent],
                    entryComponents: [OneStaticBannerComponent],
                }]
        }] });

/*
 * Public API Surface of modals and popups
 */

/**
 * Generated bundle index. Do not edit.
 */

export { OneBannerActionsComponent, OneBannerComponent, OneBannerContentComponent, OneBannerModule, OneDialogConfirmationComponent, OneDialogConfirmationModule, OneDialogConfirmationService, OneDialogModule, OneDialogSubtitleComponent, OneSnackBarComponent, OneSnackBarModule, OneSnackBarService, OneSnackBarType, OneStaticBannerComponent, OneStaticBannerModule, OneStaticBannerType, OneTooltipDirective, OneTooltipModule };
